// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"social_socialIcons__1ZxXz","git":"social_git__3DdL2","linkedin":"social_linkedin__1WNJs"};